import {
  ACTION_OVERLAY_NAV_OPEN,
} from './constants';

export const overlayNavOpen = open => ({
  open: Boolean(open),
  type: ACTION_OVERLAY_NAV_OPEN,
});
